import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    brands: [],
    models: [],
    years: [],
    variants: [],
    states: [],
    branchCount: null,
    cityCount: null,
    isModelsLoading: false,
    isBrandsLoading: false,
    isYearLoading: false,
    isVariantsLoading: false,
    isStatesLoading: false,
    selectedBrand: null,
    selectedModel: null,
    selectedYear: null,
    selectedVariant: null,
    selectedState: null,
    lastUpdatedBrand: null,
    lastUpdatedModel: null,
    lastUpdatedYear: null,
    lastUpdatedVariant: null,
    lastUpdatedState: null,
    token: null
};

export const fetchBrands = (state = INITIAL_STATE) => {
    return { ...state, isBrandsLoading: true };
};

export const fetchBrandsSuccess = (state = INITIAL_STATE, payload) => {
    const { data: { all } } = payload;
    return { ...state, brands: all, isBrandsLoading: false };
};

export const fetchBrandsFailure = (state = INITIAL_STATE) => {
    return { ...state, brands: [], isBrandsLoading: false };
};

export const fetchModels = (state = INITIAL_STATE) => {
    return { ...state, isModelsLoading: true };
};

export const fetchModelsSuccess = (state = INITIAL_STATE, { data: { all } }) => {
    return { ...state, models: all, isModelsLoading: false };
};

export const fetchModelsFailure = (state = INITIAL_STATE) => {
    return { ...state, models: [], isModelsLoading: false };
};

export const fetchYears = (state = INITIAL_STATE) => {
    return { ...state, isYearLoading: true };
};

export const fetchYearsSuccess = (state = INITIAL_STATE, { years }) => {
    return { ...state, years, isYearLoading: false };
};

export const fetchYearsFailure = (state = INITIAL_STATE) => {
    return { ...state, isYearLoading: false };
};

export const fetchVariants = (state = INITIAL_STATE) => {
    return { ...state, isVariantsLoading: true };
};

export const fetchVariantsSuccess = (state = INITIAL_STATE, { variants: variantList }) => {
    let data = [];
    Object.values(variantList).forEach((item) => {
        item.forEach((variantType) => {
            const variants = variantType.variants || [];
            data = [...data, ...variants];
        });
    });
    return { ...state, variants: data, isVariantsLoading: false };
};

export const fetchVariantsFailure = (state = INITIAL_STATE) => {
    return { ...state, isVariantsLoading: false };
};

export const fetchStates = (state = INITIAL_STATE) => {
    return { ...state, isStatesLoading: true };
};

export const fetchStatesSuccess = (state = INITIAL_STATE, { states }) => {
    const data = states.map((item) => ({
        ...item,
        displayText: `${item.state_code} - ${item.state_name}`
    }));
    return { ...state, states: data, isStatesLoading: false };
};

export const fetchStatesFailure = (state = INITIAL_STATE) => {
    return { ...state, isStatesLoading: false };
};

export const resetSelections = (state = INITIAL_STATE) => {
    return {
        ...state,
        models: [],
        years: [],
        variants: [],
        selectedBrand: null,
        selectedModel: null,
        selectedYear: null,
        selectedVariant: null,
        selectedState: null,
        lastUpdatedBrand: null,
        lastUpdatedModel: null,
        lastUpdatedYear: null,
        lastUpdatedVariant: null,
        lastUpdatedState: null,
        token: null
    };
};

export const updateSelectedBrand = (state = INITIAL_STATE, { selectedBrand }) => {
    return {
        ...state,
        selectedBrand,
        models: [],
        years: [],
        variants: [],
        selectedModel: null,
        selectedYear: null,
        selectedVariant: null,
        lastUpdatedBrand: (new Date().getTime())
    };
};

export const updateSelectedModel = (state = INITIAL_STATE, { selectedModel }) => {
    return {
        ...state,
        selectedModel,
        years: [],
        variants: [],
        selectedYear: null,
        selectedVariant: null,
        lastUpdatedModel: (new Date().getTime())
    };
};

export const updateSelectedYear = (state = INITIAL_STATE, { selectedYear }) => {
    return {
        ...state,
        selectedYear,
        variants: [],
        selectedVariant: null,
        lastUpdatedYear: (new Date().getTime())
    };
};

export const updateSelectedVariant = (state = INITIAL_STATE, { selectedVariant }) => {
    return { ...state, selectedVariant, lastUpdatedVariant: (new Date().getTime()) };
};

export const updateSelectedState = (state = INITIAL_STATE, { selectedState }) => {
    return { ...state, selectedState, lastUpdatedState: (new Date().getTime()) };
};

export const resetSpecifiedKey = (state = INITIAL_STATE, { key }) => {
    return { ...state, [key]: null };
};

export const makeLeadSuccess = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        token: data.token,
        error: null
    };
};

export const makeLeadFailure = (state = INITIAL_STATE) => {
    return { ...state, token: null };
};

export const fetchBranchCountSuccess = (state = INITIAL_STATE, { branch, city }) => {
    return { ...state, branchCount: branch, cityCount: city };
};

export const fetchBranchCountFailure = (state = INITIAL_STATE) => {
    return { ...state, branchCount: null, cityCount: null };
};

export const HANDLERS = {
    [Types.FETCH_BRANDS]: fetchBrands,
    [Types.FETCH_BRANDS_SUCCESS]: fetchBrandsSuccess,
    [Types.FETCH_BRANDS_FAILURE]: fetchBrandsFailure,
    [Types.FETCH_MODELS]: fetchModels,
    [Types.FETCH_MODELS_SUCCESS]: fetchModelsSuccess,
    [Types.FETCH_MODELS_FAILURE]: fetchModelsFailure,
    [Types.FETCH_YEAR]: fetchYears,
    [Types.FETCH_YEAR_SUCCESS]: fetchYearsSuccess,
    [Types.FETCH_YEAR_FAILURE]: fetchYearsFailure,
    [Types.FETCH_VARIANTS]: fetchVariants,
    [Types.FETCH_VARIANTS_SUCCESS]: fetchVariantsSuccess,
    [Types.FETCH_VARIANTS_FAILURE]: fetchVariantsFailure,
    [Types.FETCH_STATES]: fetchStates,
    [Types.FETCH_STATES_SUCCESS]: fetchStatesSuccess,
    [Types.FETCH_STATES_FAILURE]: fetchStatesFailure,
    [Types.RESET_SELECTIONS]: resetSelections,
    [Types.UPDATE_SELECTED_BRAND]: updateSelectedBrand,
    [Types.UPDATE_SELECTED_MODEL]: updateSelectedModel,
    [Types.UPDATE_SELECTED_YEAR]: updateSelectedYear,
    [Types.UPDATE_SELECTED_VARIANT]: updateSelectedVariant,
    [Types.UPDATE_SELECTED_STATE]: updateSelectedState,
    [Types.RESET_SPECIFIED_KEY]: resetSpecifiedKey,
    [Types.MAKE_LEAD_SUCCESS]: makeLeadSuccess,
    [Types.MAKE_LEAD_FAILURE]: makeLeadFailure,
    [Types.FETCH_BRANCH_COUNT_SUCCESS]: fetchBranchCountSuccess,
    [Types.FETCH_BRANCH_COUNT_FAILURE]: fetchBranchCountFailure
};

export default createReducer(INITIAL_STATE, HANDLERS);
